// extracted by mini-css-extract-plugin
export default {"form":"styles_form__H0-Uz","lostPassword":"styles_lostPassword__M2HFh","register":"styles_register__nike6","subtitle":"styles_subtitle__UUGtF"};